import axiosInstance from '@/services/axiosInstance'

async function subirFacturaRecibida (files, params = null) {
  try {
    if (process.env.VUE_APP_ENVIRONMENT === 'test') {
      return new Promise((resolve, reject) => {
        resolve()
      })
    } else {
      const formData = new FormData()
      files.forEach(file => {
        if (file.linkedfile) {
          formData.append(encodeURIComponent(`${file.linkedfile.attachid || file.linkedfile.linkid}_ATC_${file.attachmentid?.split('_ATC_').at(-1) || file.name}`), file.raw)
        } else {
          formData.append(encodeURIComponent(file.linkid), file.raw)
        }
        // formData.append('file', file.raw)
      })
      
      const req = {
        url: 'api/facturas/subirfacturarecibidaportal',
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data'
        },
        params,
        data: formData,
        timeout: 300000,
      }
      const res = await axiosInstance(req)
      return res.data
    }
  } catch (error) {
    return { blnError: true, msgError: error.message, codError: 'AXI001', Respuestas: null }
  }
}

export { subirFacturaRecibida }
